const EventSkeleton = () => {
  return (
    <section className="py-16 bg-white dark:bg-nexus-dark">
      <div className="container">
        {/* Header Skeleton */}
        <div className="flex justify-between items-center mb-6">
          {/* Tabs Skeleton */}
          <div className="flex gap-2">
            {Array.from({ length: 3 }).map((_, idx) => (
              <div
                key={`tab-${idx}`}
                className="h-10 w-24 rounded-md bg-gray-200 dark:bg-gray-700 animate-pulse"
              />
            ))}
          </div>
          {/* Count Skeleton */}
          <div className="h-4 w-32 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" />
        </div>

        {/* Event Cards Skeleton */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-2">
          {Array.from({ length: 6 }).map((_, idx) => (
            <div
              key={`card-${idx}`}
              className="rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden animate-pulse"
            >
              {/* Image */}
              <div className="h-48 w-full bg-gray-200 dark:bg-gray-700" />
              
              {/* Content */}
              <div className="p-4 space-y-3">
                {/* Title */}
                <div className="h-6 w-3/4 bg-gray-200 dark:bg-gray-700 rounded" />
                
                {/* Date/Time */}
                <div className="h-4 w-1/2 bg-gray-200 dark:bg-gray-700 rounded" />
                
                {/* Description */}
                <div className="space-y-2">
                  <div className="h-4 w-full bg-gray-200 dark:bg-gray-700 rounded" />
                  <div className="h-4 w-5/6 bg-gray-200 dark:bg-gray-700 rounded" />
                </div>
                
                {/* Speaker */}
                <div className="flex items-center gap-3 pt-3">
                  <div className="h-10 w-10 rounded-full bg-gray-200 dark:bg-gray-700" />
                  <div className="space-y-1">
                    <div className="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
                    <div className="h-3 w-16 bg-gray-200 dark:bg-gray-700 rounded" />
                  </div>
                </div>
                
                {/* Button */}
                <div className="h-10 w-full mt-4 bg-gray-200 dark:bg-gray-700 rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventSkeleton;